import { EResult } from '../crowd-source/task';
import { EAuthStatus, EPaymentChannel } from '../common';
import { EContractCreateStatus, EContractSignStatus } from '../contracts/contracts';
import { ESettlementStatus } from '../settlement';

export interface IFreelancerListParams {
  /** 当前页码（从1开始） */
  page: number;
  /** 每页显示条数 */
  size: number;
  /** 自由职业者编号 */
  customerNo?: string;
  /** 自由职业者名称 */
  name?: string;
  /** 身份证号 */
  idNo?: string;
  /** 手机号 */
  phone?: string;
  /** 通讯手机号 */
  contactPhone?: string;
  /** 实名状态 */
  authStatus?: EAuthStatus;
  /** 实名状态 */
  authStatuses?: string;
  /** 特代 */
  topAgentName?: string;
  /** 合作服务商 */
  serverName?: string;
  /** 合作企业 */
  companyName?: string;
  /** 业务线 */
  dutyType?: EFreelancerDutyType;
  /** 分组id */
  groupId?: string;
  /** 合同签署状态 */
  contractStatus?: EFreelancerContractStatus;
  /** 海南税源地 */
  customerHnTaxStatus?: ETaxSourceLocation;
  /** 税务登记 */
  taxCustomerStatus?: ETaxSourceRegister;
}

export interface IFreelancerItem {
  /** 自由职业者id */
  customerId: number;
  /** 自由职业者编号 */
  customerNo: string;
  /** 自由职业者名称 */
  name: string;
  /** 自由职业者身份证号 */
  idNo: string;
  /** 自由职业者实名手机号 */
  phone: string;
  /** 通讯手机号列表 */
  contactPhones: string;
  /** 业务线（众包灵工、撮合灵工） */
  dutyTypeStr: string;
  /** 分组id */
  groupId: number;
  /** 分组名称 */
  groupName: string;
  /** 合作企业 */
  companyNames: string;
  /** 所属特代 */
  topAgentNames: string;
  /** 合作服务商id列表 */
  serverIds: [];
  /** 合作服务商 */
  serverNames: string;
  /**
   * 合同签署状态
   * @description type {@link EFreelancerContractStatus}
   */
  contractStatus: EFreelancerContractStatus;
  /**
   * 实名状态（No:未实名 Yes:已实名 Ing:实名中）
   * @description type {@link EAuthStatus}
   */
  authStatus: EAuthStatus;
  /**
   * 业务线
   * @description type {@link EFreelancerDutyType}
   */
  dutyType: EFreelancerDutyType;
  /** 海南关系绑定情况（0:未入驻 1:已入驻）-- 用于前端列是否展示 */
  hnTaxStatus: ETaxSourceLocation;
  /** 海南税源地 */
  customerHnTaxStatus: ETaxSourceLocation;
}

export interface IFreelancerDetail {
  /**
   * 用户信息
   * @description type {@link IFreelancerAuthInfo}
   */
  authInfo: IFreelancerAuthInfo;
  /**
   * 小程序信息
   * @description type {@link IFreelancerAppletInfo}
   */
  appletInfo: IFreelancerAppletInfo[];
  /**
   * 银行卡信息
   * @description type {@link IFreelancerPayAccountInfo}
   */
  payAccountInfo: IFreelancerPayAccountInfo[];
  /**
   * 合同信息
   * @description type {@link IFreelancerContractInfo}
   */
  contractInfo: IFreelancerContractInfo[];
}

export interface IFreelancerAuthInfo {
  /** 姓名 */
  name: string;
  /** 身份证号 */
  idNo: string;
  /** 银行卡号 */
  bankCard: string;
  /** 手机号 */
  phone: string;
  /** 实名状态（0:未实名 1:已实名 2:实名中 */
  authStatus: EAuthStatus;
  /** 通讯手机号 */
  contactPhones: string;
  /** 常住地址 */
  address?: string;
  /** 身份证正面图片 */
  idNoFrontUrl?: string;
  /** 身份证反面图片 */
  idNoBackUrl?: string;
  /** 证件有效期-开始 */
  startDate?: string;
  /** 证件有效期-结束 */
  endDate?: string;
  /** 免冠人像图片 */
  facePictureUrl?: string;
}

export interface IFreelancerAppletInfo {
  /** 自由职业者id */
  customerId: number;
  /** 自由职业者编号 */
  customerNo: string;
  /** 昵称 */
  nickName: string;
  /** 登录手机号 */
  phone: string;
  /** 所属特级代理商 */
  topAgentName: string;
}

export interface IFreelancerPayAccountInfo {
  /** 收款账户类型 */
  payAccountType: EFreelancerPayAccountType;
  /** 收款账号 */
  payAccount: string;
  /** 累计发放金额 */
  totalAmount: number;
}

export interface IFreelancerContractInfo {
  /** 合同名称 */
  contractName: string;
  /** 签署方 */
  signer: string;
  /** 签署方类型 */
  signerType: number;
  /**
   * 合同状态(真实合同状态) 1：待签署 2：签署中 3：已完成 4：已撤销 5：已逾期 6：已终止 7：作废中 8：已作废
   * @description type {@link EContractCreateStatus}
   */
  status: EContractCreateStatus;
  /**
   * 签署状态 1：待签署 2：已签署 3：已逾期 4：已拒签 5：已作废
   * @description type {@link EContractSignStatus}
   */
  signStatus: EContractSignStatus;
  /** 签署完成时间 格式 yyyy-MM-dd HH:mm:ss */
  finishTime: string;
  /** 合同到期时间 格式 yyyy-MM-dd HH:mm:ss */
  expireTime: string;
}

export interface IFreelancerCreate {
  /** 服务商id */
  serverId: number;
  /** 分组id */
  groupId: number;
  /** 姓名 */
  name: string;
  /** 身份证号 */
  idNo: string;
  /** 银行卡号 */
  bankCard: string;
  /** 手机号 */
  phone: string;
  /** 支付宝账号 */
  alipayAccount: string;
}

export interface IFreelancerGroupItem {
  /** 分组id */
  groupId: number;
  /** 分组名称 */
  groupName: string;
  /**
   * 分组类型（0：默认分组 、1：自定义分组）
   * @description type {@link EFreelancerGroupType}
   */
  groupType: EFreelancerGroupType;
}

export enum EFreelancerGroupType {
  /** 默认分组 */
  DEFAULT = 0,
  /** 自定义分组 */
  CUSTOMIZE = 1,
}

export interface IImportFreelancerParams {
  /** 分组id */
  groupId: number;
  /** 服务商id */
  serverId: number;
  /** 人员信息文件url */
  fileUrl: string;
}

export interface IImportFreelancer {
  /** 分组id */
  groupId?: number;
  /** 服务商id */
  serverId?: number;
  /** 校验结果列表 */
  items: IFreelancerImportItem[];
}

export interface IFreelancerImportItem {
  /** 自由职业者名称 */
  name: string;
  /** 自由职业者身份证号 */
  idNo: string;
  /** 自由职业者银行卡号 */
  bankCard: string;
  /** 自由职业者实名手机号 */
  phone: string;
  /** 实名状态 */
  authStatus?: EAuthStatus;
  /** 校验结果 0?:不通过 1?:通过 */
  result?: EResult;
  /** 校验不通过原因 */
  errorMsg?: string;
}

export enum EFreelancerDutyType {
  /** 众包灵工 */
  CROWD = 0,
  /** 撮合灵工 */
  MATCH = 1,
}

export const freelancerDutyTypeLabel = {
  [EFreelancerDutyType.CROWD]: '众包灵工',
  [EFreelancerDutyType.MATCH]: '撮合灵工',
};

export enum EFreelancerContractStatus {
  /** 未签署 */
  UNSIGNED = 0,
  /** 已签署 */
  SIGNED = 1,
  /** 未完全签署 */
  NOT_FULLY_SIGNED = 2,
}

export const freelancerContractStatusLabel = {
  [EFreelancerContractStatus.UNSIGNED]: '未签署',
  [EFreelancerContractStatus.SIGNED]: '已签署',
  [EFreelancerContractStatus.NOT_FULLY_SIGNED]: '未全部签署',
};

export enum ETaxSourceLocation {
  /** 已入驻 */
  YES = 1,
  /** 未入驻 */
  NO = 0,
}

export const freelancerTaxSourceLocationLabel = {
  [ETaxSourceLocation.YES]: '已绑定',
  [ETaxSourceLocation.NO]: '未绑定',
};

export const freelancerTaxSourceLocationStyle = {
  [ETaxSourceLocation.YES]: 'success',
  [ETaxSourceLocation.NO]: 'info',
};

export enum ETaxSourceRegister {
  /** 已登记 */
  YES = 1,
  /** 未登记 */
  NO = 0,
}

export const freelancerTaxSourceRegisterLabel = {
  [ETaxSourceRegister.YES]: '已登记',
  [ETaxSourceRegister.NO]: '未登记',
};

export const freelancerTaxSourceRegisterStyle = {
  [ETaxSourceRegister.YES]: 'success',
  [ETaxSourceRegister.NO]: 'info',
};

export interface IFreelancerDistributionRecordParams {
  /** 当前页码（从1开始） */
  page: number;
  /** 每页显示条数 */
  size: number;
  /** 身份证号 【pc端须传入】 */
  personIdNumber?: string;
  /** 订单状态(成功传SUCCEED_PAY;失败传FAIL_PAY 【小程序端分页须传入】) */
  orderDetailStatus?: string;
  /** 个人银行卡账号 【pc端须传入】 */
  personBank?: string;
  /** 订单状态(成功传SUCCEED_PAY;失败传FAIL_PAY 【小程序端分页须传入】) */
  orderDetailStatusList?: string[];
}

export interface IFreelancerDistributionRecordItem {
  /** 订单明细id */
  orderDetailId: number;
  /** 订单编号 */
  orderNo: string;
  /** 子订单编号 */
  orderDetailNo: string;
  /** 公司id */
  companyId: number;
  /** 服务商id */
  serverId: number;
  /** 任务id */
  dutyId: number;
  /** 企业名称 */
  companyName: string;
  /** 所属服务商 */
  serverName: string;
  /** 任务名称 */
  dutyName: string;
  /** 订单类型(0众包订单 1智客订单) */
  orderType: EFreelancerDutyType;
  /** 到账金额 */
  receivedAmount: number;
  /** 订单状态： CHECK_PENDING-待审核, CHECK_REJECT-审核驳回, UNPAID-待支付, TIME_PUSH-定时发放,DURING_PAY-支付中,SUCCEED_PAY-交易成功,FAIL_PAY-交易失败,CANCEL_PAY-交易取消,REEXCHANGE-退汇) */
  orderDetailStatus: ESettlementStatus;
  /** 订单结束时间 */
  endTime: string;
  /** 支付通道(0-招商银行,1-连连支付) */
  payType: EPaymentChannel;
  /** 使用产品 */
  productName: string;
}

export enum EFreelancerSmsType {
  /** 实名+合同签署通知模版 */
  CUSTOMER_AUTH = 19,
  /** 入驻海南税源地通知模版 */
  HN_TAX = 20,
  /** 个人信息补充通知模版(海南) */
  HN_AUTH = 21,
  /** 个人信息补充通知模版(海南代开票) */
  HN_INVOICE = 22,
  /** 活体认证 */
  LIVENESS_AUTH = 24,
}

export const freelancerSmsTypeLabel = {
  [EFreelancerSmsType.CUSTOMER_AUTH]: '非海南业务通知模版',
  [EFreelancerSmsType.HN_TAX]: '海南业务通知模版',
  [EFreelancerSmsType.HN_AUTH]: '个人信息补充通知模版(海南)',
  [EFreelancerSmsType.HN_INVOICE]: '个人信息补充通知模版(海南代开票)',
  [EFreelancerSmsType.LIVENESS_AUTH]: '活体认证',
};

export interface ISendSmsFreelancerParams {
  /** 短信类型 */
  sendType: EFreelancerSmsType;
  /** 自由职业者身份证号列表 */
  idNos: string[];
  /** 企业id */
  companyId: number;
  /** 任务ID */
  dutyId?: number;
}

export interface IFreelancerSmsTemplateResp {
  /** 短信类型 */
  sendType: EFreelancerSmsType;
  /** 短信模板名称	 */
  templateName: string;
}

export interface IImportDutyFreelancerParams {
  /** 任务id */
  dutyId: number;
  /** 人员信息文件url */
  fileUrl: string;
}

export interface IFreelancerDutyItme {
  /** 自由职业者id */
  customerId: number;
  /** 自由职业者编号 */
  customerNo: string;
  /** 自由职业者名称 */
  name: string;
  /** 自由职业者身份证号 */
  idNo: string;
  /** 自由职业者银行卡号 */
  bankCard: string;
  /** 自由职业者手机号 */
  phone: string;
  /** 自由职业者通讯手机号列表	 */
  phoneList: string[];
  /** 自由职业者银行卡号列表	 */
  bankCardList: string[];
  /** 自由职业者支付宝账号列表	 */
  alipayAccountList: string[];
}

export interface IFreelancerServerItme {
  /** 服务商id */
  serverId: number;
  /** 服务商名称 */
  serverName: string;
}

export interface IFreelancerBankAddParams {
  /** 收款账号 */
  bankCard: string;
  /** 自由职业者身份证号 */
  idNo: string;
}

export interface IFreelancerAddPayAccountParams {
  /** 收款账号 */
  payAccount: string;
  /** 自由职业者身份证号 */
  idNo: string;
  /** 收款账户类型 */
  payAccountType: EFreelancerPayAccountType;
}

export enum EFreelancerPayAccountType {
  /** 支付宝 */
  ALIPAY = 'ALIPAY',
  /** 银行卡 */
  BANK = 'BANK'
}

export const freelancerPaymentMethodLabel = {
  [EFreelancerPayAccountType.ALIPAY]: '支付宝',
  [EFreelancerPayAccountType.BANK]: '银行卡',
};

export interface IFreelancerDutyGroupItem {
  /** 分组id */
  groupId: number;
  /** 分组名称 */
  groupName: string;
  /** */
  children: IFreelancerDutyItme[];
}

export interface IUpdateHnAuthDateParam{
  /** 身份证号 */
  idNo?: string;
  /** 海南授权时间 */
  hnAuthDate?: string;
}